/**
 * The panel every tag-mapping overlay draws its content in.
 *
 * ONE constant because two of them drifted. The timeseries overlay was built
 * responsive — up to 1400px wide and nearly the full height — while the file
 * preview kept a fixed 1000x700 card, so opening a mapped tag and opening its
 * source file gave two differently-sized windows onto the same review. Pratima:
 * "for tag mapping preview the eye icon should open the overlay in same way ...
 * it should be as bigger as time series one they should have same size".
 *
 * Responsive rather than fixed, and that is the half that matters beyond
 * matching: a P&ID or a 500-column historian export is worth the whole screen,
 * and a fixed card wastes most of a large monitor while overflowing a small one.
 * `min()` keeps it from sprawling on an ultrawide, and the `calc` leaves room
 * for the chrome the frame puts in the corners.
 *
 * The margins are the frame's (Figma 13, measured on the 1611x1006 app area
 * it is drawn over): the panel sits 100px from the top and bottom edges and
 * 234px from each side — 10% and 14.5% of the screen — with the Original |
 * Detected toggle and Close in the top margin and the zoom bar in the bottom
 * one, 14px into their corners. Percentages, so a larger screen keeps the
 * frame's proportions rather than a fixed panel in a sea of grey; `max()`
 * so a short screen still clears the 46px chrome rows plus their 14px
 * inset. Before this the panel ran to 24px of the bottom edge and the zoom
 * bar sat across its lower-left corner.
 */
export const OVERLAY_PANEL_CLASS =
  'absolute left-1/2 top-[max(10%,76px)] bottom-[max(10%,76px)] flex w-[min(1400px,71%)] ' +
  '-translate-x-1/2 flex-col overflow-hidden rounded-[10px] bg-white ' +
  'dark:border dark:border-dark-border dark:bg-dark-card'
